import { flowDirectionSchema } from '@sevone/insight-connect';

const flowDirectionType = {
  id: 'flowDirection',
  schema: flowDirectionSchema
};

export { flowDirectionType };
